export const imageFileExtensionList = ["png", "jpg", "jpeg", "gif"];
